import type { FaireProductEntity } from "../../entity_types/product";

export const p_2u4x792n84: FaireProductEntity = {
  token: "p_2u4x792n84",
  type: "product",
  name: "Witch Tea Towel | Halloween Tea Towel | Fall Home Decor",
  brandToken: "b_wws7d39tvc",
  brandName: "Madison’s Pop Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/4ee5a2bea3b0c2784a86eabde85c9af510e6498ad5b557eca19b57f7fc3e37a4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/92802058cc2472ab28e6c1a4aa1b40e74cdf8011e7a3e92c7f92123f1dd99b0a.jpeg",
    "https://cdn.faire.com/fastly/bb152300040634db4fc4a9c3e4de36600704fce7a3db34413fe2095cab2de296.jpeg",
  ],
  priceDollars: 6,
  description:
    "This Halloween Tea Towel is sure to Bring a little Halloween magic to your kitchen! Whether you’re decorating for spooky season, hosting a Halloween party, baking pumpkin treats, or searching for the perfect seasonal gift, these towels add a playful touch to any home.\n\nEach towel is handmade with care and features a unique Halloween-inspired design that’s perfect for displaying on your oven handle, coffee bar, tiered tray, or kitchen counter throughout the fall season.\n\n🖤 Product Details\n\n* 100% cotton tea towel\n* Bright white fabric\n* Soft, smooth finish\n* Professionally printed design\n* Handmade with love\n* Perfect for seasonal decorating and gifting\n\n🎃 Perfect For\n\n* Halloween kitchen decor\n* Fall home decorating\n* Hostess gifts\n* Halloween party gifts\n* Pumpkin lovers\n* Seasonal gift exchanges\n* Friends, coworkers, and family\n\n🧡 Care Instructions\n\n* Machine wash cold\n* Tumble dry low or hang dry\n* Iron on reverse side if needed\n* Do not bleach\n\nWhether you’re a pumpkin enthusiast, candy connoisseur, Halloween decorator, or simply love all things fall, these festive tea towels are a fun way to celebrate the season!\n\n👻 Handmade with love in Florida.\n\n#HalloweenDecor #HalloweenTeaTowel #FallKitchenDecor #SpookySeason #PumpkinDecor #HalloweenGift #FunnyTeaTowel #FallDecor #KitchenTowel #SeasonalDecor #HalloweenKitchen #HostessGift #HandmadeGift #MadisonsPopShop 🎃🧡👻",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:47.181Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
